import { useCallback, useState, useEffect } from 'react';
import { useAppMessage, useLocalParticipant } from '@daily-co/daily-react';
import { sessionUsersAtom } from '../../State';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { useTranslation } from 'react-i18next';
import { getImagePath } from '../Util/utils';
import KUTE from 'kute.js';
import { isMobile } from 'react-device-detect';

export default function LiveList({ showMemberList, toggleMemberList }) {
  //Recoil
  const sessionUsers = useRecoilValue(sessionUsersAtom);

  //その他
  const [speakerArrayState, setSpeakerArray] = useState([]);
  const [viewerArrayState, setViewerArray] = useState([]);
  const { t } = useTranslation();

  //セッション情報を元に更新
  useEffect(() => {
    if (Object.keys(sessionUsers).length > 0) {
      var existingUserIDs = [];
      var existingUserName = [];
      var speakerArray = [];
      var viewerArray = [];
      //オブジェクトとしてユーザーの処理
      Object.keys(sessionUsers).forEach(function (key) {
        var user = sessionUsers[key];

        var flg = true;
        var existingUserNameFlg = true;

        //重複を削除
        if (user.userID != null) {
          if (existingUserIDs.includes(user.userID) == false) {
            existingUserIDs.push(user.userID);
          } else {
            flg = false;
          }
        }

        //名前の重複削除
        if (user.displayName != null) {
          if (existingUserName.includes(user.displayName) == false) {
            existingUserName.push(user.displayName);
          } else {
            //existingUserNameFlg = false;
          }
        }

        if (flg && existingUserNameFlg) {
          if (user.userType == 'speaker' || user.userType == 'owner') {
            speakerArray.push(user);
          } else {
            viewerArray.push(user);
          }
        }
      });

      setSpeakerArray(speakerArray);
      setViewerArray(viewerArray);
    }
  }, [sessionUsers]);

  useEffect(() => {
    if (isMobile && showMemberList) {
      let kute = KUTE.to(
        '.chat',
        { top: 'calc(env(safe-area-inset-top) + 0px)' },
        {
          duration: 300,
          easing: 'easingCubicOut',
          onComplete: () => {},
        },
      );
      kute.start();
    }
  }, [showMemberList]);

  function toggleFunc() {
    if (isMobile) {
      let kute = KUTE.to(
        '.chat',
        { top: window.innerHeight },
        {
          duration: 300,
          easing: 'easingCubicOut',
          onComplete: () => {
            toggleMemberList();
          },
        },
      );
      kute.start();
    } else {
      toggleMemberList();
    }
  }

  return showMemberList ? (
    <aside className="chat">
      <div id="chatHead">
        <div id="chatTitle">{t('chat.Members')}</div>
        <button onClick={toggleFunc} id="chatCloseButton">
          ×
        </button>
      </div>

      <div className="memberListWrap">
        <div className="memberTitle">{t('chat.Speaker')}</div>
        <ul>
          {speakerArrayState?.map((user, index) => (
            <li key={`spaker-${index}`}>
              {user.nftID != null ? (
                <img
                  src={'https://d2wp3sepl8g4xv.cloudfront.net/model/images/' + user.nftID + '.png'}
                />
              ) : (
                <img src={getImagePath() + '/icons/logoIcon.png'} />
              )}
              <span>{user.displayName}</span>
            </li>
          ))}
        </ul>
        <div className="memberTitle">{t('chat.Listener')}</div>
        <ul>
          {viewerArrayState?.map((user, index) => (
            <li key={`viewer-${index}`}>
              {user.nftID != null ? (
                <img
                  src={'https://d2wp3sepl8g4xv.cloudfront.net/model/images/' + user.nftID + '.png'}
                />
              ) : (
                <img src={getImagePath() + '/icons/logoIcon.png'} />
              )}
              <span>{user.displayName}</span>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  ) : null;
}
